import { Observable } from "rxjs";

import { BaseRestService } from "../BaseRestService";
import {
  PostExpertPaymentsResponse,
  TipaltiIframes
} from "../models/expertPayments";
import { restService } from "../restService";

export class ExpertPaymentsService {
  // cspell:disable-next-line
  private static readonly Endpoint = "/expertpayments";

  private readonly _restService: BaseRestService;

  constructor(restService: BaseRestService) {
    this._restService = restService;
  }

  public getIframes(expertId?: string): Observable<TipaltiIframes> {
    return this._restService.get(`${ExpertPaymentsService.Endpoint}/iframes`, {
      expertId
    });
  }

  public newGetIframes(
    expertId?: string,
    expertPaymentGateWayId?: string
  ): Observable<TipaltiIframes> {
    return this._restService.get(
      `${ExpertPaymentsService.Endpoint}/${expertPaymentGateWayId}/iframes`,
      expertId
        ? {
            expertId
          }
        : undefined
    );
  }

  public createIframes(
    expertId?: string
  ): Observable<PostExpertPaymentsResponse> {
    return this._restService.post<PostExpertPaymentsResponse>(
      `${ExpertPaymentsService.Endpoint}/${expertId}/payments`,
      {}
    );
  }
}

export const DefaultExpertPaymentsService = new ExpertPaymentsService(
  restService
);
